import { goldenColor, headingBlue, red } from "../../assets/colors";

export const titleStyle = {
    backgroundColor: headingBlue,
    color: 'white',
    fontSize:'1rem',
    display: "flex",
    alignItems: 'center',
    padding: "0.4rem 0rem 0.4rem 1rem",
    height: "1.8rem"
}

export const cardOuterBoxStyle= {
    marginTop: '1rem',
    padding: "1rem 0.2rem 1rem 0.2rem",
    width: '98%',
    // display: 'flex',
    // flexDirection: 'row',
    // justifyContent: "center",
    // // justifyContent: 'center',
    // alignItems: 'center',
    // border: '1px solid'
}

export const cardStyle = {
    height: '9.8rem',
    width: '15.75rem',
    border: '1px solid',
    padding: '0.7rem 0.15rem 0.7rem 0.15rem',
    // borderRadius: '0.4rem',
    backgroundColor: '#ffffff',
    // backgroundImage: `url(${require('../../assets/images/3px-tile.png')})`,
//   backgroundSize: 'cover',
//   backgroundBlendMode: 'screen',
}

export const headerBoxStyle = {
    height: '2.8rem',
    width: '100%',
    // border: '1px solid green',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'flex-end'
}

export const logoStyle = {
    height: '2.8rem',
    padding: '0rem 0rem 0.3rem 0rem'
}

export const headingStyle={
    fontWeight: "600",
    fontSize: '0.9rem',
    padding: '0rem 0rem 0rem 0.5rem'
}

export const bodyBoxStyle = {
    
    height: '5.6rem',
    // border: '1px solid green',
    padding: '0.5rem 0.1rem 0rem 0rem',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-end'
}

export const detailsBoxStyle= {
    height: '5rem',
    width: '11.2rem',
    display: 'flex',
    alignItems: 'flex-end',
    // border: '1px solid maroon'
}

export const photoBoxStyle = {
    width: '4rem',
    height: '4.6rem',
    // border: '1px solid blue',
    display: 'flex',
    alignItems: 'center',
    
}

export const tableStyle ={
    height: '100%'
}

export const photoStyle = {
    width: '4rem',
    height: '4.6rem'
}

export const detailsTableRowStyle = {
    fontSize: '0.6rem',
    fontWeight: "700"
}

export const backCardStyle = {
    height: '9.9rem',
    width:'16rem',
    border: '1px solid',
    padding: '0.1rem 0rem 0.1rem 0rem',
    // borderRadius: '0.4rem',
    backgroundColor: '#ffffff',
    // backgroundImage: `url(${require('../../assets/images/3px-tile.png')})`,
//   backgroundSize: 'cover',
//   backgroundBlendMode: 'screen',
}

export const imageStyle = {
    height: '9.6rem',
    width: '15.87rem',
    // borderRadius: '0.4rem',
}

export const backAddressBoxStyle = {
    padding: '0rem 0.2rem 0.1rem 0.2rem',
    display: 'flex',
    justifyContent: 'center',
    width: '98%'
}

export const backAddressTextStyle = {
    fontSize: '0.6rem', 
    fontWeight: 600
}

export const backColorStripStyle = {
    height: '0.45rem'
}

export const backBodyOuterBoxStyle = {
    display: 'flex',
    // flexDirection: 'column',
    height: '55%',
    alignItems: 'flex-end'
}

export const backWORKlogoBoxStyle= {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'flex-end',
    border: '1px solid'
}

export const backWORKlogoStyle = {
    height: '2rem',
    width: '3rem'
}

export const backSlogansBoxStyle = {
    textAlign: 'center',
    width: '60%'
}

export const backSlogansTextStyle = {
    // textAlign: 'justify',
    textAlign: 'center',
    alignItems: 'center',
    fontSize: '0.6rem',
    fontWeight: 600
}

export const backContactNumberOuterBoxStyle = {
    display: 'flex',
    justifyContent: 'center'
}

export const backContactNumberinnerBoxStyle = {
    display: 'flex',
    justifyContent: 'center',
    padding: '0.1rem 0.5rem 0.1rem 0.5rem'
}

export const backContactNumberTextStyle = {
    fontSize: '0.6rem',
    fontWeight: 600
}

export const noteTextStyle= {
    fontSize: '0.7rem',
    fontWeight: 400,
    color: red
}
 